// СКОПИРУЙТЕ ЭТОТ КОД ПОЛНОСТЬЮ В ФАЙЛ src/hooks/useAuth.ts

import React from 'react';
import { authApi } from '@/services/api/auth';
import { AdminUser, AdminRole, AdminPermissions } from '@/services/api';

interface AuthState {
  user: AdminUser | null;
  role: AdminRole | null;
  permissions: AdminPermissions | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

interface AuthContextValue extends AuthState {
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  refreshProfile: () => Promise<void>;
}

const AuthContext = React.createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider = (props: { children: React.ReactNode }) => {
  const [authState, setAuthState] = React.useState<AuthState>({
    user: null,
    role: null,
    permissions: null,
    token: localStorage.getItem('admin_token'),
    isAuthenticated: false,
    isLoading: true,
  });

  const login = async (username: string, password: string) => {
    try {
      const response = await authApi.login(username, password);
      const data = response.data.data;
      
      localStorage.setItem('admin_token', data.token);
      
      setAuthState({
        user: data.user,
        role: data.role,
        permissions: data.permissions,
        token: data.token,
        isAuthenticated: true,
        isLoading: false,
      });
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setAuthState({
      user: null,
      role: null,
      permissions: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,
    });
  };

  const refreshProfile = async () => {
    try {
      const response = await authApi.getProfile();
      const data = response.data.data;

      setAuthState(prev => ({
        ...prev,
        user: data.user,
        role: data.role,
        permissions: data.permissions,
        isAuthenticated: true,
        isLoading: false,
      }));
    } catch (error) {
      logout();
    }
  };

  React.useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      refreshProfile();
    } else {
      setAuthState(prev => ({ ...prev, isLoading: false }));
    }
  }, []);

  const value: AuthContextValue = {
    ...authState,
    login,
    logout,
    refreshProfile,
  };

  return React.createElement(
    AuthContext.Provider,
    { value },
    props.children
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};